<template>
  <scrollactive
    class="my-nav"
    active-class="active-sc"
    :modifyUrl="false"
    :scrollOnStart="false"
    :offset="72"
    :duration="600"
    bezier-easing-value=".5,0,.35,1"
  >
    <navbar
      position="fixed"
      type="ees"
      :transparent="transparent"
      :color-on-scroll="colorOnScroll"
      menu-classes="ml-auto"
    >
      <template :slot-scope="{ toggle, isToggled }">
        <router-link class="navbar-brand" to="/" @click.native="scrollFix('#top')">
          <img class="n-logo" style="max-height: 40px;" src="img/ees-logo.png" alt />
        </router-link>
      </template>
      <template slot="navbar-menu">
        <li class="nav-item">
          <nav-link to="/#about" scrollactive-item data-section-selector="#about">
            <p>¿Quiénes somos?</p>
          </nav-link>
        </li>
        <li class="nav-item">
          <nav-link to="/#services" scrollactive-item data-section-selector="#services">
            <p>Servicios</p>
          </nav-link>
        </li>
        <li class="nav-item">
          <nav-link to="/#projects" scrollactive-item data-section-selector="#projects">
            <p>Proyectos</p>
          </nav-link>
        </li>
        <li class="nav-item">
          <nav-link to="/#team" scrollactive-item data-section-selector="#team">
            <p>Equipo</p>
          </nav-link>
        </li>
        <li class="nav-item">
          <nav-link to="/#contact" scrollactive-item data-section-selector="#contact">
            <p>Contacto</p>
          </nav-link>
        </li>
        <li class="nav-item">
          <a
            class="nav-link"
            href="https://admin.seesdata.com/"
            target="_blank"
          >
            <p>Admin</p>
          </a>
        </li>
      </template>
    </navbar>
  </scrollactive>
</template>

<script>
import { DropDown, NavbarToggleButton, Navbar, NavLink } from "@/components";
import VueScrollTo from "vue-scrollto";
export default {
  name: "main-navbar",
  props: {
    transparent: Boolean,
    colorOnScroll: Number
  },
  components: {
    DropDown,
    Navbar,
    NavbarToggleButton,
    NavLink,
    VueScrollTo: VueScrollTo
  },
  methods: {
    scrollFix: hashbang => {
      VueScrollTo.scrollTo(hashbang, 700);
    },
    closeNav() {
      if (this.closeNavbar) {
        this.closeNavbar();
      }
      if (this.closeDropDown) {
        this.closeDropDown();
      }
    }
  }
};
</script>

<style scoped></style>
